<template>
<v-navigation-drawer
  permanent
  app
  :src="require('../assets/clouds5.jpg')"
  persistent
  mobile-break-point="640"
  :mini-variant="miniVariant"
  :clipped="clipped"
  v-model="drawer"
  fixed
  >

  <v-divider></v-divider>

  <v-list
    shaped
    >

    <router-link :to="item.path"
                 v-for="item in items"
                 :key="item.title"
                 link
                 >
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="amber darken-4" v-text="item.icon"></v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>

      </v-list-item>

    </router-link>

  </v-list>
</v-navigation-drawer>
</template>


<script>
export default {
    data: () => ({
        clipped: true,
        drawer: true,
        fixed: true,
        right: false,
        rightDrawer: false,
        items: [
            // {
            //     title: 'Home',
            //     path: '/ui/home',
            //     icon: 'fa-igloo',
            // },
            // {
            //     title: 'Deliveries',
            //     path: '/ui/deliveries',
            //     icon: 'fa-box',
            // },
            {
                title: 'Models',
                path: '/ui/models',
                icon: 'far fa-square',
            },
            {
                title: 'Sources',
                path: '/ui/sources',
                icon: 'fa-database',
            },
            {
                title: 'Points API',
                path: '/ui/points',
                icon: 'fa-map-marker-alt',
            },
            {
                title: 'Settings',
                path: '/ui/settings',
                icon: 'fa-tools',
            },
        ],
    }),

    computed: {
        miniVariant() {
            return this.$store.getters.miniVariant;
        },
    },
};
</script>

<style lang="scss" scoped>
  a {
      text-decoration: none;
  }
</style>
